import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { h3, paragraph } from '@helpers/typography';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import Controls from '../Carousel/Controls/Controls';
import { transition } from '@helpers/animate';
const Container = styled(SectionWrapper) `
  --bgColor: ${brand.white};
  --fgColor: ${brand.black};
  --itemGutter: 24px;
  --visibleItems: 1;

  color: var(--fgColor);
  margin-top: 5rem;
  margin-bottom: 5rem;
  overflow-x: hidden;

  @media ${from(Device.Tablet)} {
    --visibleItems: 2;
  }

  @media ${from(Device.DesktopSmall)} {
    --itemGutter: 40px;
    --visibleItems: 3;
  }
`;
const Track = styled(MotionTrack) `
  margin-top: 3rem;
`;
const Title = styled.h2 `
  ${h3};
  margin-bottom: 0;
`;
const Content = styled.div `
  ${paragraph};
  margin-top: 1rem;
  margin-bottom: 0;
  max-width: 65ch;
`;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems));
  padding-right: var(--itemGutter);
`;
const PaginationWrapper = styled.div `
  margin: 2rem 0 0;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0.5rem;
  align-items: center;
`;
const Pagination = styled.div `
  grid-column: span 9;

  @media ${from(Device.Tablet)} {
    grid-column: 3 / span 8;
  }
`;
const TestButtonContainer = styled.div `
  text-align: center;
  padding-bottom: 12px;
`;
const StyledControls = styled(Controls) `
  grid-column: 10 / span 3;
  justify-self: end;
  display: flex;
  gap: 0.5rem;

  @media ${from(Device.Tablet)} {
    grid-column: 11 / span 2;
  }
`;
const Button = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 5000000px;
  color: ${brand.black};
  background-color: transparent;

  &:disabled {
    opacity: 0.5;

    &:hover {
      opacity: 0.5;
    }
  }

  &:hover,
  &:focus {
    svg {
      path {
        ${transition('stroke-width')}
        stroke-width: 5;
      }
    }
  }

  &:first-child {
    svg {
      transform: scaleX(-1);
    }
  }

  svg {
    height: 36px;
  }
`;
const FullWidthCarouselStyles = {
    Button,
    Container,
    Content,
    Controls: StyledControls,
    Item,
    Pagination,
    PaginationWrapper,
    Title,
    Track,
    TestButtonContainer,
};
export default FullWidthCarouselStyles;
